// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ allowedRoles = [], children}) => { // children 추가
    const { loginState, loginUserInfo } = useSelector((state) => state.auth);

    const hasAccess = loginState && allowedRoles.length > 0 && allowedRoles.includes(loginUserInfo.user.perm_id);

    return hasAccess ? children : loginState? <Navigate to="/forbidden" replace /> :  <Navigate to="/login" replace /> ;
};

export default ProtectedRoute;
